import { declareVueComponent } from '/vodalys/vvuejs/vueRegister.mjs'

import TroubleshootingPage from './TroubleshootingPage.vue'
declareVueComponent('troubleshootingPage', TroubleshootingPage);

import TroubleshootingPageStatus from './TroubleshootingPageStatus.vue'
declareVueComponent('troubleshootingPageStatus', TroubleshootingPageStatus);

import TroubleshootingPageHttpStatus from './TroubleshootingPageHttpStatus.vue'
declareVueComponent('troubleshootingPageHttpStatus', TroubleshootingPageHttpStatus);

import TroubleshootingPageWebsocketStatus from './TroubleshootingPageWebsocketStatus.vue'
declareVueComponent('TroubleshootingPageWebsocketStatus', TroubleshootingPageWebsocketStatus);

import TroubleshootingPageWebRTCStatus from './TroubleshootingPageWebRTCStatus.vue'
declareVueComponent('TroubleshootingPageWebRTCStatus', TroubleshootingPageWebRTCStatus);

import TroubleshootingPagePlatform from './TroubleshootingPagePlatform.vue'
declareVueComponent('TroubleshootingPagePlatform', TroubleshootingPagePlatform);

import TroubleshootingPageGeographicZone from './TroubleshootingPageGeographicZone.vue'
declareVueComponent('troubleshootingPageGeographicZone', TroubleshootingPageGeographicZone);